import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { ViewTitle } from '../components/reusable'
import { ILAddClientsView } from '../components/views/ILAddClientsView'
import { ILClientDetailsView } from '../components/views/ILClientDetailsView'

function ILClientDetails() {
    return (
        <div className="ilClientDetails">
            <Sidebar />
            <MainView>
                <ViewTitle text={'Irresponsible Lending Client Details'} />
                <ILClientDetailsView />
            </MainView>
        </div>
    )
}

export default ILClientDetails
